import { CommentIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/CommentIcon';
import LazyLoadImage from '@bnnvara/lazy-load';
import { Tag } from '@bnnvara/tags';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import BaseCardBody from './BaseCardBody';
import BaseCardMetaData from './BaseCardMetaData';
import * as S from './styled';
const BaseCardWrapper = styled.div`
  ${S.StyledBaseCardWrapper}
  ${props => S[props.backgroundImage]};
  ${props => S[props.backgroundColor]};
  ${props => S[props.minHeightLg]}
  ${props => S[props.wide]};
`;

const tagType = backgroundImage => backgroundImage ? 'primary' : 'secondary';

const BaseCard = /*#__PURE__*/React.forwardRef(({
  tag,
  icon,
  followAction,
  title,
  brand,
  pubDate,
  hasBodyBackground,
  backgroundImage,
  darkenImage,
  backgroundColor,
  titleSizeSm,
  titleSizeMd,
  titleSizeLg,
  minHeightLg,
  wide,
  isLazyLoaded,
  smWithBorder,
  follow,
  followMobile,
  commentCount
}, ref) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BaseCardWrapper, {
  hasBodyBackground: hasBodyBackground,
  backgroundColor: backgroundColor,
  minHeightLg: minHeightLg,
  wide: wide,
  ref: ref,
  smWithBorder: smWithBorder
}, commentCount > 0 && /*#__PURE__*/React.createElement(S.CommentCount, null, /*#__PURE__*/React.createElement(CommentIcon, null), commentCount), backgroundImage && /*#__PURE__*/React.createElement(S.CardImageContainer, {
  wide: wide,
  dark: darkenImage
}, isLazyLoaded ? /*#__PURE__*/React.createElement(LazyLoadImage, {
  as: S.CardImage,
  src: backgroundImage,
  dark: darkenImage,
  alt: `Afbeelding van ${title}`
}) : /*#__PURE__*/React.createElement(S.CardImage, {
  as: S.CardImage,
  src: backgroundImage,
  alt: `Afbeelding van ${title}`
}), icon && /*#__PURE__*/React.createElement(S.BaseCardIconBox, {
  onClick: followAction,
  wide: wide
}, icon)), tag && /*#__PURE__*/React.createElement(S.BaseCardTag, null, /*#__PURE__*/React.createElement(Tag, {
  type: tagType(backgroundImage)
}, tag)), /*#__PURE__*/React.createElement(S.BaseCardBodyContainer, null, /*#__PURE__*/React.createElement(BaseCardBody, {
  hasBodyBackground: hasBodyBackground,
  titleSizeSm: titleSizeSm,
  titleSizeMd: titleSizeMd,
  titleSizeLg: titleSizeLg,
  wide: wide
}, title), (brand || pubDate) && /*#__PURE__*/React.createElement(BaseCardMetaData, {
  hasBodyBackground: hasBodyBackground
}, brand && /*#__PURE__*/React.createElement("span", null, brand, " \u2022 "), pubDate), followMobile)), follow));
BaseCard.defaultProps = {
  icon: null,
  followAction: null,
  tag: null,
  brand: null,
  backgroundImage: null,
  backgroundColor: null,
  hasBodyBackground: false,
  titleSizeSm: null,
  titleSizeMd: null,
  titleSizeLg: null,
  minHeightLg: null,
  pubDate: null,
  wide: false,
  isLazyLoaded: false,
  darkenImage: false,
  smWithBorder: false,
  follow: null,
  followMobile: null,
  commentCount: 0
};
BaseCard.propTypes = {
  icon: PropTypes.node,
  followAction: PropTypes.func,
  tag: PropTypes.string,
  title: PropTypes.string.isRequired,
  brand: PropTypes.string,
  pubDate: PropTypes.string,
  backgroundImage: PropTypes.string,
  backgroundColor: PropTypes.string,
  hasBodyBackground: PropTypes.bool,
  titleSizeSm: PropTypes.string,
  titleSizeMd: PropTypes.string,
  titleSizeLg: PropTypes.string,
  minHeightLg: PropTypes.string,
  wide: PropTypes.bool,
  isLazyLoaded: PropTypes.bool,
  darkenImage: PropTypes.bool,
  smWithBorder: PropTypes.bool,
  follow: PropTypes.node,
  followMobile: PropTypes.node,
  commentCount: PropTypes.number
};
export default BaseCard;